/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable prefer-const */

import { authState } from 'rxfire/auth';
import { docData } from 'rxfire/firestore';
import { Observable, Subscription, BehaviorSubject, firstValueFrom } from 'rxjs';
import { filter, first } from 'rxjs/operators';
import { globalTrackingService, baseStore, loadingHelper } from '@recruiting-solutions/rs-shared';

import { ApplyService } from './apply.service';

import { FavoriteJob, CandidateUser } from '../models/candidateUser';

import {
    createUserWithEmailAndPassword,
    EmailAuthProvider,
    fetchSignInMethodsForEmail,
    getAdditionalUserInfo,
    getAuth,
    getRedirectResult,
    GoogleAuthProvider,
    isSignInWithEmailLink,
    linkWithCredential,
    linkWithPopup,
    OAuthCredential,
    OAuthProvider,
    ProviderId,
    reauthenticateWithCredential,
    SAMLAuthProvider,
    signInAnonymously,
    signInWithEmailAndPassword,
    signInWithEmailLink,
    signInWithPopup,
    User,
    UserCredential,
} from 'firebase/auth';
import { deleteDoc, doc, DocumentReference, getDoc, setDoc } from '@firebase/firestore';
import { getFirestore } from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { CsbHelper, getConfig, getConfigValue } from '@recruiting-solutions/rs-shared';
const de: {
    close: string;
    confirm: string;
    email: string;
    emailDesc: string;
    codeInvalidTitle: string;
    codeInvalid: string;
    'auth/invalid-email': string;
    'auth/user-not-found': string;
    'auth/wrong-password': string;
    'auth/too-many-requests': string;
    'auth/email-already-in-use': string;
    'auth/operation-not-allowed': string;
    'auth/weak-password': string;
    'auth-error-expired-action-code': string;
} = {
    close: 'Schließen',
    confirm: 'Einloggen',
    email: 'Bitte E-Mail Adresse erneut eingeben',
    emailDesc: 'Der Login Link wurde auf einem anderen Gerät, Browser oder ein zweites Mal geöffnet. Bitte E-Mail Adresse erneut verifizieren.',
    codeInvalidTitle: 'Login ungültig',
    codeInvalid: 'Der Link ist abgelaufen. Bitte erneut anmelden.',
    'auth/invalid-email': 'Die eingegebene E -Mail -Adresse ist ungültig',
    'auth/user-not-found': 'Die eingegebene E -Mail -Adresse ist nicht registriert',
    'auth/wrong-password': 'Das eingegebene Passwort ist falsch',
    'auth/too-many-requests': 'Das Login ist fehlgeschlagen',
    'auth/email-already-in-use': 'Die eingegebene E -Mail -Adresse ist bereits registriert',
    'auth/operation-not-allowed': 'Das Login war nicht erfolgreich',
    'auth/weak-password': 'Das eingegebene Passwort ist zu schwach',
    'auth-error-expired-action-code': 'Ihr Link ist abgelaufen',
};

const en: {
    close: string;
    confirm: string;
    email: string;
    emailDesc: string;
    codeInvalidTitle: string;
    codeInvalid: string;
    'auth/invalid-email': string;
    'auth/user-not-found': string;
    'auth/wrong-password': string;
    'auth/too-many-requests': string;
    'auth/email-already-in-use': string;
    'auth/operation-not-allowed': string;
    'auth/weak-password': string;
    'auth-error-expired-action-code': string;
} = {
    close: 'Close',
    confirm: 'Log in',
    email: 'Please confirm your email address',
    emailDesc: 'The login link was already opened on another Device/Browser or was opened a second time. Please revalidate your email address.',
    codeInvalidTitle: 'Login invalid',
    codeInvalid: 'Your link has expired, please log in again.',
    'auth/invalid-email': 'The entered email address is invalid',
    'auth/user-not-found': 'The entered email address is not registered',
    'auth/wrong-password': 'The entered password is incorrect',
    'auth/too-many-requests': 'The login failed',
    'auth/email-already-in-use': 'The entered email address is already registered',
    'auth/operation-not-allowed': 'The login was not successful',
    'auth/weak-password': 'The entered password is too weak',
    'auth-error-expired-action-code': 'Your link has expired',
};

const tr: {
    close: string;
    confirm: string;
    email: string;
    emailDesc: string;
    codeInvalidTitle: string;
    codeInvalid: string;
    'auth/invalid-email': string;
    'auth/user-not-found': string;
    'auth/wrong-password': string;
    'auth/too-many-requests': string;
    'auth/email-already-in-use': string;
    'auth/operation-not-allowed': string;
    'auth/weak-password': string;
    'auth-error-expired-action-code': string;
} = {
    close: 'Kapalı',
    confirm: 'Giriş yapmak',
    email: 'Lütfen e-posta adresinizi doğrulayın',
    emailDesc: 'Giriş bağlantısı zaten başka bir cihazda/tarayıcıda açıldı veya ikinci kez açıldı. Lütfen e -posta adresinizi gözden geçirin.',
    codeInvalidTitle: 'Giriş geçersiz',
    codeInvalid: 'Bağlantınızın süresi doldu, lütfen tekrar giriş yapın',
    'auth/invalid-email': 'Girilen e -posta adresi geçersiz',
    'auth/user-not-found': 'Girilen e -posta adresi kayıtlı değil',
    'auth/wrong-password': 'Girilen şifre yanlış',
    'auth/too-many-requests': 'Giriş başarısız oldu',
    'auth/email-already-in-use': 'Girilen e -posta adresi zaten kayıtlı',
    'auth/operation-not-allowed': 'Giriş başarılı değildi',
    'auth/weak-password': 'Girilen şifre çok zayıf',
    'auth-error-expired-action-code': 'Bağlantınızın süresi doldu',
};

const pl: {
    close: string;
    confirm: string;
    email: string;
    emailDesc: string;
    codeInvalidTitle: string;
    codeInvalid: string;
    'auth/invalid-email': string;
    'auth/user-not-found': string;
    'auth/wrong-password': string;
    'auth/too-many-requests': string;
    'auth/email-already-in-use': string;
    'auth/operation-not-allowed': string;
    'auth/weak-password': string;
    'auth-error-expired-action-code': string;
} = {
    close: 'Zamknąć',
    confirm: 'Zaloguj sie',
    email: 'proszę potwierdź swój adres E-mail',
    emailDesc: 'Link logowania został już otwarty na innym urządzeniu/przeglądarce lub został otwarty po raz drugi. Przejmuj swój adres e -mail.',
    codeInvalidTitle: 'Nieprawidłowa nazwa użytkownika',
    codeInvalid: 'Twój link wygasł, zaloguj się ponownie',
    'auth/invalid-email': 'Wpisany adres e -mail jest nieprawidłowy',
    'auth/user-not-found': 'Wprowadzony adres e -mail nie jest zarejestrowany',
    'auth/wrong-password': 'Wprowadzone hasło jest nieprawidłowe',
    'auth/too-many-requests': 'Logowanie nie powiodło się',
    'auth/email-already-in-use': 'Wpisany adres e -mail jest już zarejestrowany',
    'auth/operation-not-allowed': 'Logowanie nie było powodzeniem',
    'auth/weak-password': 'Wprowadzone hasło jest zbyt słabe',
    'auth-error-expired-action-code': 'Wprowadzone hasło jest zbyt słabe',
};

const pt: {
    close: string;
    confirm: string;
    email: string;
    emailDesc: string;
    codeInvalidTitle: string;
    codeInvalid: string;
    'auth/invalid-email': string;
    'auth/user-not-found': string;
    'auth/wrong-password': string;
    'auth/too-many-requests': string;
    'auth/email-already-in-use': string;
    'auth/operation-not-allowed': string;
    'auth/weak-password': string;
    'auth-error-expired-action-code': string;
} = {
    close: 'Fechar',
    confirm: 'Conecte-se',
    email: 'Por favor, confirme seu endereço de email',
    emailDesc: 'O link de login já foi aberto em outro dispositivo/navegador ou foi aberto pela segunda vez. Revalide seu endereço de e -mail.',
    codeInvalidTitle: 'Login inválido',
    codeInvalid: 'Seu link expirou, faça login novamente',
    'auth/invalid-email': 'O endereço de e -mail inserido é inválido',
    'auth/user-not-found': 'O endereço de e -mail inserido não está registrado',
    'auth/wrong-password': 'A senha inserida está incorreta',
    'auth/too-many-requests': 'O login falhou',
    'auth/email-already-in-use': 'O endereço de e -mail inserido já está registrado',
    'auth/operation-not-allowed': 'O login não foi bem -sucedido',
    'auth/weak-password': 'A senha inserida é muito fraca',
    'auth-error-expired-action-code': 'Seu link expirou',
};

const es: {
    close: string;
    confirm: string;
    email: string;
    emailDesc: string;
    codeInvalidTitle: string;
    codeInvalid: string;
    'auth/invalid-email': string;
    'auth/user-not-found': string;
    'auth/wrong-password': string;
    'auth/too-many-requests': string;
    'auth/email-already-in-use': string;
    'auth/operation-not-allowed': string;
    'auth/weak-password': string;
    'auth-error-expired-action-code': string;
} = {
    close: 'Cerca',
    confirm: 'Acceso',
    email: 'Por favor confirme su dirección de correo electrónico',
    emailDesc: 'El enlace de inicio de sesión ya estaba abierto en otro dispositivo/navegador o se abrió por segunda vez. Revaliden su dirección de correo electrónico.',
    codeInvalidTitle: 'Inicio de sesión no válido',
    codeInvalid: 'Su enlace ha caducado, vuelva a iniciar sesión',
    'auth/invalid-email': 'La dirección de correo electrónico ingresada no es válida',
    'auth/user-not-found': 'La dirección de correo electrónico ingresada no está registrada',
    'auth/wrong-password': 'La contraseña ingresada es incorrecta',
    'auth/too-many-requests': 'El inicio de sesión falló',
    'auth/email-already-in-use': 'La dirección de correo electrónico ingresada ya está registrada',
    'auth/operation-not-allowed': 'El inicio de sesión no tuvo éxito',
    'auth/weak-password': 'La contraseña ingresada es demasiado débil',
    'auth-error-expired-action-code': 'Tu enlace ha expirado',
};

const hu: {
    close: string;
    confirm: string;
    email: string;
    emailDesc: string;
    codeInvalidTitle: string;
    codeInvalid: string;
    'auth/invalid-email': string;
    'auth/user-not-found': string;
    'auth/wrong-password': string;
    'auth/too-many-requests': string;
    'auth/email-already-in-use': string;
    'auth/operation-not-allowed': string;
    'auth/weak-password': string;
    'auth-error-expired-action-code': string;
} = {
    close: 'Bezárás',
    confirm: 'Belépés',
    email: 'Kérem erősítse meg email címét',
    emailDesc: 'A bejelentkezési linket már megnyitották egy másik eszközön/böngészőn, vagy másodszor nyitották meg. Kérjük, kérjük, újjáélessze e -mail címét.',
    codeInvalidTitle: 'Érvénytelen bejelentkezés',
    codeInvalid: 'A linkje lejárt, kérjük, jelentkezzen be újra',
    'auth/invalid-email': 'A beírt e -mail cím érvénytelen',
    'auth/user-not-found': 'A beírt e -mail címet nem regisztrálták',
    'auth/wrong-password': 'A beírt jelszó helytelen',
    'auth/too-many-requests': 'A bejelentkezés meghibásodott',
    'auth/email-already-in-use': 'A beírt e -mail cím már regisztrált',
    'auth/operation-not-allowed': 'A bejelentkezés nem volt sikeres',
    'auth/weak-password': 'A beírt jelszó túl gyenge',
    'auth-error-expired-action-code': 'A linked lejárt',
};

const nl: {
    close: string;
    confirm: string;
    email: string;
    emailDesc: string;
    codeInvalidTitle: string;
    codeInvalid: string;
    'auth/invalid-email': string;
    'auth/user-not-found': string;
    'auth/wrong-password': string;
    'auth/too-many-requests': string;
    'auth/email-already-in-use': string;
    'auth/operation-not-allowed': string;
    'auth/weak-password': string;
    'auth-error-expired-action-code': string;
} = {
    close: 'Dichtbij',
    confirm: 'Login',
    email: 'Bevestig je e-mailadres',
    emailDesc: 'De inlogkoppeling werd al geopend op een ander apparaat/browser of werd een tweede keer geopend. Revalideer uw e -mailadres opnieuw.',
    codeInvalidTitle: 'Inloggen ongeldig',
    codeInvalid: 'Uw link is verlopen, log alstublieft opnieuw in',
    'auth/invalid-email': 'Het ingevoerde e -mailadres is ongeldig',
    'auth/user-not-found': 'Het ingevoerde e -mailadres is niet geregistreerd',
    'auth/wrong-password': 'Het ingevoerde wachtwoord is onjuist',
    'auth/too-many-requests': 'De login is mislukt',
    'auth/email-already-in-use': 'Het ingevoerde e -mailadres is al geregistreerd',
    'auth/operation-not-allowed': 'De login was niet succesvol',
    'auth/weak-password': 'Het ingevoerde wachtwoord is te zwak',
    'auth-error-expired-action-code': 'Uw link is verlopen',
};

const it: {
    close: string;
    confirm: string;
    email: string;
    emailDesc: string;
    codeInvalidTitle: string;
    codeInvalid: string;
    'auth/invalid-email': string;
    'auth/user-not-found': string;
    'auth/wrong-password': string;
    'auth/too-many-requests': string;
    'auth/email-already-in-use': string;
    'auth/operation-not-allowed': string;
    'auth/weak-password': string;
    'auth-error-expired-action-code': string;
} = {
    close: 'Invio',
    confirm: 'Login',
    email: 'Conferma il tuo indirizzo email',
    emailDesc: 'Il collegamento di accesso era già stato aperto su un altro dispositivo/browser o è stato aperto una seconda volta. Si prega di rivalidare il tuo indirizzo email.',
    codeInvalidTitle: 'Accesso non valido',
    codeInvalid: 'Il tuo link è scaduto, per favore accedi di nuovo',
    'auth/invalid-email': "L'indirizzo e -mail inserito non è valido",
    'auth/user-not-found': "L'indirizzo e -mail inserito non è registrato",
    'auth/wrong-password': 'La password inserita non è corretta',
    'auth/too-many-requests': "L'accesso non è riuscito",
    'auth/email-already-in-use': "L'indirizzo e -mail inserito è già registrato",
    'auth/operation-not-allowed': "L'accesso non ha avuto successo",
    'auth/weak-password': 'La password inserita è troppo debole',
    'auth-error-expired-action-code': 'Il tuo link è scaduto',
};

const fr: {
    close: string;
    confirm: string;
    email: string;
    emailDesc: string;
    codeInvalidTitle: string;
    codeInvalid: string;
    'auth/invalid-email': string;
    'auth/user-not-found': string;
    'auth/wrong-password': string;
    'auth/too-many-requests': string;
    'auth/email-already-in-use': string;
    'auth/operation-not-allowed': string;
    'auth/weak-password': string;
    'auth-error-expired-action-code': string;
} = {
    close: 'Fermer',
    confirm: 'Se connecter',
    email: 'Merci de confirmer votre adresse e-mail',
    emailDesc: 'Le lien de connexion a déjà été ouvert sur un autre appareil / navigateur ou a été ouvert une deuxième fois. Veuillez revalider votre adresse e-mail.',
    codeInvalidTitle: 'Connexion invalide',
    codeInvalid: 'Votre lien a expiré, veuillez vous reconnecter',
    'auth/invalid-email': "L'adresse e-mail saisie n'est pas valide",
    'auth/user-not-found': "L'adresse e-mail saisie n'est pas enregistrée",
    'auth/wrong-password': 'Le mot de passe entré est incorrect',
    'auth/too-many-requests': 'La connexion a échoué',
    'auth/email-already-in-use': "L'adresse e-mail saisie est déjà enregistrée",
    'auth/operation-not-allowed': "La connexion n'a pas réussi",
    'auth/weak-password': 'Le mot de passe entré est trop faible',
    'auth-error-expired-action-code': 'Votre lien a expiré',
};

class AuthServiceController {
    translations: any = {
        de_CH: de,
        de_DE: de,
        en_US: en,
        es_ES: es,
        fr_FR: fr,
        hu_HU: hu,
        it_IT: it,
        nl_NL: nl,
        pl_PL: pl,
        pt_PT: pt,
        tr_TR: tr,
        default: en,
    };

    private _user: BehaviorSubject<CandidateUser | undefined> = new BehaviorSubject<CandidateUser | undefined>(undefined);
    user$: Observable<CandidateUser | undefined> = this._user.asObservable();

    private _isInitializing: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    isInitializing: Observable<boolean> = this._isInitializing.asObservable();

    token?: string;
    authSubscription?: Subscription;
    userSubscription?: Subscription;
    firebaseStoreUserSubscription?: Subscription;
    mergeInternal?: boolean;

    async waitForInitialUser(): Promise<CandidateUser> {
        return firstValueFrom(this.user$.pipe(filter(u => !!u))) as any;
    }

    init() {
        const customerId = this.getCustomerId();
        const auth = getAuth();
        if (auth) {
            auth.tenantId = getConfigValue('tenantId'); // "p78Staging-1u947"; //TODO: get from config value
            console.log('TenantId: ' + auth.tenantId);

            if (CsbHelper.getInternal()) {
                getRedirectResult(auth)
                    .then(user => {
                        if (user) {
                            console.log('Internal Login User from redirect', user);
                        }
                    })
                    .catch(error => {
                        console.error('Error during login', error);
                    });
            }

            this.authSubscription = authState(auth).subscribe(async firebaseUser => {
                if (firebaseUser && !firebaseUser.isAnonymous) {
                    this.handlePasswordDelete();
                    await this.handlePasswordlessLogin();
                    this.token = (await firebaseUser.getIdTokenResult()).token;
                    const firebaseStoreUser = await this.getFirebaseStoreUser(customerId, firebaseUser.uid);
                    if (firebaseStoreUser && firebaseStoreUser.tenantId) {
                        this._user.next(firebaseStoreUser);
                    }
                } else {
                    // await this.handlePasswordlessLogin();
                    if (CsbHelper.getInternal()) {
                        console.log('Handling internal auth');
                        this.internalLogin().then(user => {
                            console.log('Internal user', user);
                        });
                    } else {
                        await this.handlePasswordlessLogin();
                    }
                }
                this._isInitializing.next(false);
            });

            this.user$.subscribe(async user => {
                console.log('set user in state to', user);
                if (user) {
                    if (CsbHelper.getInternal()) {
                        if (!user.candidateId) {
                            ApplyService.getInternalCandidateId()
                                .then(candidateId => {
                                    user.candidateId = candidateId;
                                    baseStore.state.user = user;
                                })
                                .catch(err => {
                                    console.error(err);
                                    baseStore.state.user = user;
                                });
                        } else {
                            baseStore.state.user = user;
                        }
                    } else {
                        baseStore.state.user = user;
                    }
                }
            });
        }
    }

    public refreshToken() {
        const auth = getAuth();
        return new Promise<string>((resolve, reject) => {
            this.authSubscription = authState(auth).subscribe(async firebaseUser => {
                if (firebaseUser) {
                    try {
                        console.log('Refreshed auth token');
                        this.token = (await firebaseUser.getIdTokenResult(true)).token;
                    } catch (error) {
                        console.warn('Refreshing auth token error', error);
                        reject(error);
                    }
                    resolve(this.token || '');
                } else {
                    const reason = {
                        message: {
                            lang: 'en-US',
                            value: 'Something went wrong, please try it again.',
                        },
                    };
                    reject(reason);
                }
            });
        });
    }

    async deleteTempUser(): Promise<void> {
        const auth = getAuth();
        return await auth.currentUser?.delete();
    }

    createPassword(length = 12) {
        let result = '';
        const upperCaseCharacters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const otherCharacters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!&$%?';

        const charactersLength = otherCharacters.length;
        for (let i = 0; i < length; i++) {
            const random = Math.floor(Math.random() * charactersLength);
            result += otherCharacters.charAt(random);
            if (i === 5) {
                result += upperCaseCharacters.charAt(random % 26);
            }
        }
        return result;
    }

    getCustomerId(): string {
        const customerId = getConfigValue('customerId');

        // if (customerId === 'p78-prod') {
        //   return 'p78-staging';
        // }
        return customerId;
    }

    private handlePasswordDelete() {
        const auth = getAuth();
        const config = getConfig();
        if (auth.currentUser && isSignInWithEmailLink(auth, window.location.href)) {
            if (window.location.href.indexOf(config.accountDeletedUrl!) != -1) {
                let email = window.localStorage.getItem('emailForSignIn');
                if (!email) {
                    // User opened the link on a different device. To prevent session fixation
                    // attacks, ask the user to provide the associated email again. For example:
                    email = window.prompt('Please provide your email for confirmation');
                }
                console.log('deleting account');

                const credential = EmailAuthProvider.credentialWithLink(email!, window.location.href);

                // Re-authenticate the user with this credential.
                reauthenticateWithCredential(auth.currentUser, credential)
                    .then(async usercred => {
                        // The user is now successfully re-authenticated and can execute sensitive
                        // operations.
                        console.log('deleting account for realz');
                        await usercred.user.delete();
                    })
                    .catch(error => {
                        // Some error occurred.
                        console.error(error);
                    });
            }
        }
    }

    private async handlePasswordlessLogin() {
        const auth = getAuth();
        if (isSignInWithEmailLink(auth, window.location.href)) {
            const loading = loadingHelper.setLoading('login');
            const customerId = this.getCustomerId();
            let email = window.localStorage.getItem('emailForSignIn');
            if (!email) {
                // User opened the link on a different device. To prevent session fixation
                // attacks, ask the user to provide the associated email again. For example:
                const emailConfirmDialogElement = window.document.querySelector('csb-email-confirm-dialog') as any;

                if (emailConfirmDialogElement) {
                    emailConfirmDialogElement.addEventListener(
                        'modalConfirmed',
                        async (event: CustomEvent) => {
                            const returnEmail = event.detail.email;

                            if (returnEmail) {
                                await this.handlePasswordlessLoginInternal(returnEmail, customerId);
                                loading.off();
                            }
                        }
                    );

                    emailConfirmDialogElement.show();
                } else {
                    const locale = CsbHelper.getLocale();
                    let translation = this.translations[locale];
                    if (!translation) {
                        translation = this.translations.default;
                    }
                    const mailConfirmDialog = document.createElement('csb-email-confirm-dialog') as any;
                    mailConfirmDialog.buttonTag = 'csb-button';
                    mailConfirmDialog.emailPlaceholder = 'E-Mail';
                    mailConfirmDialog.confirmLabel = translation.confirm;
                    mailConfirmDialog.errorCloseLabel = translation.close;
                    mailConfirmDialog.emailTitle = translation.email;
                    mailConfirmDialog.emailDescription = translation.emailDesc;

                    mailConfirmDialog.innerHTML = `
                        <csb-email-confirm-friendly-error code="auth/invalid-email" message="${translation['auth-error-invalid-email']}></csb-email-confirm-friendly-error>
                        <csb-email-confirm-friendly-error code="auth/user-not-found" message="${translation['auth-error-user-not-found']}></csb-email-confirm-friendly-error>
                        <csb-email-confirm-friendly-error code="auth/wrong-password" message="${translation['auth-error_wrong-password']}></csb-email-confirm-friendly-error>
                        <csb-email-confirm-friendly-error code="auth/too-many-requests" message="${translation['auth-error-too-many-requests']}></csb-email-confirm-friendly-error>
                        <csb-email-confirm-friendly-error code="auth/email-already-in-use" message="${translation['auth-error-email-already-in-use']}></csb-email-confirm-friendly-error>
                        <csb-email-confirm-friendly-error code="auth/operation-not-allowed" message="${translation['auth-error-operation-not-allowed']}></csb-email-confirm-friendly-error>
                        <csb-email-confirm-friendly-error code="auth/weak-password" message="${translation['auth-error-weak-password']}></csb-email-confirm-friendly-error>
                        <csb-email-confirm-friendly-error code="auth/expired-action-code" message="${translation['auth-error-expired-action-code']}></csb-email-confirm-friendly-error>
                    `;

                    document.body.appendChild(mailConfirmDialog);

                    setTimeout(() => {
                        mailConfirmDialog.addEventListener(
                            'modalConfirmed',
                            async (event: CustomEvent) => {
                                const returnEmail = event.detail.email;

                                if (returnEmail) {
                                    await this.handlePasswordlessLoginInternal(returnEmail, customerId);
                                    loading.off();
                                }
                            }
                        );

                        mailConfirmDialog.show();
                    }, 200);
                    // email = window.prompt('Please provide your email for confirmation') || '';
                    // await this.handlePasswordlessLoginInternal(email, customerId);
                }
            } else {
                await this.handlePasswordlessLoginInternal(email, customerId);
                loading.off();
            }
        }
    }

    async handlePasswordlessLoginInternal(email: string, customerId: string) {
        const auth = getAuth();
        if (auth.currentUser && auth.currentUser.isAnonymous) {
            const favoriteJobs: any[] = this.getFavoriteJobs();
            await AuthService.deleteTempUser();
            await this.signInWithoutPassword(email, favoriteJobs, customerId);
            window.localStorage.removeItem('emailForSignIn');
        } else {
            baseStore.state.newUser = false;
            try {
                await this.signInWithoutPassword(email, [], customerId);
            } catch (error) {
                console.error(error);
                baseStore.state.error = error;
                baseStore.state.errorId = 'wrong_email';
            } finally {
                window.localStorage.removeItem('emailForSignIn');
            }
        }
    }

    private async signInWithoutPassword(email: string, favoriteJobs: any[], customerId: string) {
        try {
            const auth = getAuth();
            const mailLink = window.location.href;
            this.deleteParamsFromUrl();
            const user = await signInWithEmailLink(auth, email, mailLink);
            console.log('Current Auth User: ' + JSON.stringify(auth.currentUser));
            await AuthService.setCandidate(favoriteJobs);
            this.getFirebaseStoreUser(customerId, user.user.uid).then(firebaseStoreUser => {
                if (firebaseStoreUser && !firebaseStoreUser.candidateId) {
                    this._user.next(firebaseStoreUser);
                }
            });
        } catch (error) {
            if ((error as any).code === 'auth/invalid-action-code') {
                this.deleteParamsFromUrl();
                const locale = CsbHelper.getLocale();
                const items = document.getElementsByTagName('csb-info-modal');
                let translation = this.translations[locale];
                if (!translation) {
                    translation = this.translations.default;
                }
                const text = translation.codeInvalid;
                const title = translation.codeInvalidTitle;
                const closeLabel = translation.close;
                if (items.length > 0) {
                    await (items.item(0) as any).open(title, text, closeLabel);
                } else {
                    const csbInfoModal = document.createElement('csb-info-modal') as any;
                    document.body.appendChild(csbInfoModal);
                    await csbInfoModal.open(title, text, closeLabel);
                }
            } else {
                const emailConfirmDialogElement = window.document.querySelector('csb-email-confirm-dialog') as any;

                if (emailConfirmDialogElement) {
                    emailConfirmDialogElement.showError(error);
                }

                console.error(error);
            }
        }
    }

    deleteParamsFromUrl() {
        const newParams = new URLSearchParams(window.location.search);
        const paramsToDelete: string[] = [];
        const doNotDelete = [
            'extJobId',
            'applySourceOverride',
            'utm_campaign',
            'utm_source',
            'locale',
            'overrideEmployeeLogin',
            'isInternalUser',
            'referralCode',
            'jobId',
            'showApply',
            'showJobAlert',
            'jobPipeline',
        ];
        newParams.forEach((_value, key) => {
            if (doNotDelete.indexOf(key) === -1) {
                paramsToDelete.push(key);
            }
        });
        paramsToDelete.forEach(param => {
            newParams.delete(param);
        });
        let newUrl = window.location.pathname + (newParams?.toString() ? '?' + newParams?.toString() : '');
        window.history.replaceState({}, '', `${newUrl}`);
    }

    getUserDocRef(customerId: string, userId: string) {
        const firebaseStore = getFirestore();
        const docRef = doc(firebaseStore, `customers/${customerId}/users/${userId}`) as DocumentReference<CandidateUser>;
        return docRef;
    }

    async getUserDocSnap(customerId: string, userId: string) {
        const docRef = this.getUserDocRef(customerId, userId);
        const docSnap = await getDoc(docRef);
        return docSnap;
    }

    async getFirebaseStoreUser(customerId: string, uid: string): Promise<CandidateUser> {
        const auth = getAuth();
        const fbUser = auth.currentUser;
        if (!fbUser) {
            throw new Error('Current User empty');
        }
        if (!(await this.getUserDocSnap(customerId, uid)).exists) {
            const newCandidateUser: CandidateUser = {
                displayName: fbUser.displayName || '',
                email: fbUser.email || '',
                phoneNumber: fbUser.phoneNumber || '',
                photoURL: fbUser.photoURL || '',
                providerId: fbUser.providerId,
                uid: fbUser.uid,
                enabled: false,
                tenantId: customerId,
                isAnonymous: false,
            };
            await setDoc(this.getUserDocRef(customerId, fbUser.uid), newCandidateUser, { merge: true });
        }
        return new Promise(res => {
            this.firebaseStoreUserSubscription = docData<CandidateUser>(this.getUserDocRef(customerId, uid))
                .pipe(first(user => !!(user && user.tenantId)))
                .subscribe(user => {
                    if (user && user.tenantId) {
                        res(user);
                    }
                });
        });
    }

    // TODO move to favorite service !!!!!

    public async favoriteJob(job: { jobId: string; title: string; link: string }) {
        let result = false;
        const customerId = this.getCustomerId();

        const fbuser = await this.createOrGetTempUser();
        if (fbuser.isAnonymous) {
            //save favorite jobs in local baseStore
            console.log('baseStore user in anon: ', baseStore.state.user);
            if (!baseStore.state.user?.favoriteJobs) {
                baseStore.state.user!.favoriteJobs = [];
            }
            const exists = baseStore.state.user?.favoriteJobs.findIndex((x: { jobId: string }) => x.jobId === job.jobId);

            if (exists === -1) {
                const favoriteJob: FavoriteJob = {
                    date: new Date(),
                    jobId: job.jobId,
                    title: job.title,
                    link: job.link,
                };
                baseStore.state.user?.favoriteJobs.push(favoriteJob);
                if (baseStore.state.user) {
                    baseStore.state.user = { ...baseStore.state.user };
                }
                result = true;
            } else {
                //unfavor
                baseStore.state.user?.favoriteJobs.splice(exists!, 1);
                if (baseStore.state.user) {
                    baseStore.state.user = { ...baseStore.state.user };
                }
            }
            localStorage.setItem('favoriteJobs', JSON.stringify(baseStore.state.user?.favoriteJobs));
        } else {
            localStorage.removeItem('favoriteJobs');
            const user = await this.getFirebaseStoreUser(customerId, fbuser.uid);

            if (!user.favoriteJobs) {
                user.favoriteJobs = [];
            }
            const exists = user.favoriteJobs.findIndex(x => x.jobId === job.jobId);

            if (exists === -1) {
                const favoriteJob: FavoriteJob = {
                    date: new Date(),
                    jobId: job.jobId,
                    title: job.title,
                    link: job.link,
                };
                user.favoriteJobs.push(favoriteJob);
                if (baseStore.state.user) {
                    baseStore.state.user = { ...user };
                }
                result = true;
            } else {
                //unfavor
                user.favoriteJobs.splice(exists, 1);
                if (baseStore.state.user) {
                    baseStore.state.user = { ...user };
                }
            }
            await setDoc(this.getUserDocRef(customerId, user.uid), { favoriteJobs: user.favoriteJobs }, { merge: true });
        }
        return result;
    }

    public async linkedInLogin() {
        const customerId = this.getCustomerId();

        const provider = new OAuthProvider('linkedin.com');

        let linkedInUser: UserCredential;
        const auth = getAuth();
        if (auth.currentUser && !auth.currentUser.isAnonymous) {
            console.log('Joining linkedin google account');
            linkedInUser = await linkWithPopup(auth.currentUser, provider);
        } else {
            console.log('Sign in with linkedin account');

            linkedInUser = await signInWithPopup(auth, provider);
            const additionalUserInfo = getAdditionalUserInfo(linkedInUser);
            if (additionalUserInfo?.isNewUser) {
                const randomPw = AuthService.createPassword();
                const credential = EmailAuthProvider.credential(linkedInUser.user.email!, randomPw);
                await linkWithCredential(linkedInUser.user, credential);
            }
            await this.setCandidate(this.getFavoriteJobs());
        }
        return new Promise<CandidateUser | undefined>(resolve => {
            this.userSubscription = docData<CandidateUser>(this.getUserDocRef(customerId, linkedInUser.user.uid)).subscribe(u => {
                resolve(u);
            });
        });
    }

    public async passwordLessLogin(email: string, rawUrl?: string | URL, useLocalStorage: boolean = true) {
        const auth = getAuth();
        const customerId = this.getCustomerId();
        const locale = CsbHelper.getLocale();
        let brand = await CsbHelper.getBrand();

        const blacklist: string[] = getConfig().internalMailBlacklist || [];

        if (blacklist.length) {
            let splitMail = email.split('@');
            if (splitMail.length > 1) {
                const host = splitMail[splitMail.length - 1];
                if (blacklist.find(x => x === host)) {
                    throw new Error('blacklisted');
                }
            }
        }

        //TODO: Do not forget to implement the brand call for other customers.
        if (useLocalStorage) {
            window.localStorage.setItem('emailForSignIn', email);
        }

        const fireFunctions = getFunctions();
        const sendLoginMailFunction = httpsCallable(fireFunctions, 'sendLoginMail');

        let url = rawUrl ? new URL(rawUrl) : new URL(window.location.href);
        url.pathname = url.pathname.replace(/\&/g, '%26');

        console.log('Current TenantID:', auth.tenantId);
        const result = await sendLoginMailFunction({ customerId, email, locale, url: url.toString(), brand: brand.brand });

        console.log('Result from sendLoginMail', result);
    }

    public async microsoftLogin() {
        const customerId = this.getCustomerId();
        const auth = getAuth();
        const provider = new OAuthProvider('microsoft.com');
        provider.setCustomParameters({
            // Optional "tenant" parameter in case you are using an Azure AD tenant.
            // eg. '8eaef023-2b34-4da1-9baa-8bc8c9d6a490' or 'contoso.onmicrosoft.com'
            // or "common" for tenant-independent tokens.
            // The default value is "common".
            // tenant: getConfigValue('microsoftClientId')
        });
        let msUser: UserCredential;
        if (auth.currentUser && !auth.currentUser.isAnonymous) {
            console.log('Joining with microsoft account');
            msUser = await linkWithPopup(auth.currentUser, provider);
        } else {
            console.log('Sign in with microsoft account');

            msUser = await signInWithPopup(auth, provider);
            const additionalUserInfo = getAdditionalUserInfo(msUser);
            if (additionalUserInfo?.isNewUser) {
                const randomPw = AuthService.createPassword();
                const credential = EmailAuthProvider.credential(msUser.user.email!, randomPw);
                await linkWithCredential(msUser.user, credential);
            }
            await this.setCandidate(this.getFavoriteJobs());
        }
        return new Promise<CandidateUser | undefined>(resolve => {
            this.userSubscription = docData<CandidateUser>(this.getUserDocRef(customerId, msUser.user.uid)).subscribe(u => {
                resolve(u);
            });
        });
    }

    public async appleLogin() {
        const customerId = this.getCustomerId();
        const auth = getAuth();
        const provider = new OAuthProvider('apple.com');
        provider.addScope('email');

        let appleUser: UserCredential;
        if (auth.currentUser && !auth.currentUser.isAnonymous) {
            console.log('Joining with apple account');
            appleUser = await linkWithPopup(auth.currentUser, provider);
        } else {
            console.log('Sign in with apple account');

            appleUser = await signInWithPopup(auth, provider);
            const additionalUserInfo = getAdditionalUserInfo(appleUser);
            if (additionalUserInfo?.isNewUser) {
                const randomPw = AuthService.createPassword();
                const credential = EmailAuthProvider.credential(appleUser.user.email!, randomPw);
                await linkWithCredential(appleUser.user, credential);
            }
            await this.setCandidate(this.getFavoriteJobs());
        }
        return new Promise<CandidateUser | undefined>(resolve => {
            this.userSubscription = docData<CandidateUser>(this.getUserDocRef(customerId, appleUser.user.uid)).subscribe(u => {
                resolve(u);
            });
        });
    }

    public async googleLogin() {
        const customerId = this.getCustomerId();
        const auth = getAuth();
        const provider = new GoogleAuthProvider();
        const currentUser = auth.currentUser;
        let googleUser: UserCredential;
        if (currentUser && !currentUser.isAnonymous) {
            console.log('Joining with google account');
            googleUser = await linkWithPopup(currentUser, provider);
        } else {
            console.log('Sign in with google account');
            googleUser = await signInWithPopup(auth, provider);
            const additionalUserInfo = getAdditionalUserInfo(googleUser);
            if (additionalUserInfo?.isNewUser) {
                const randomPw = AuthService.createPassword();
                const credential = EmailAuthProvider.credential(googleUser.user.email!, randomPw);
                await linkWithCredential(googleUser.user, credential);
            }

            await this.setCandidate(this.getFavoriteJobs());
        }

        return new Promise<CandidateUser | undefined>(resolve => {
            this.userSubscription = docData<CandidateUser>(this.getUserDocRef(customerId, googleUser.user.uid)).subscribe(u => {
                resolve(u);
            });
        });
    }

    public async login(email: string, pw: string) {
        const auth = getAuth();
        const customerId = this.getCustomerId();
        const user = await signInWithEmailAndPassword(auth, email, pw);

        return new Promise<CandidateUser | undefined>(resolve => {
            this.userSubscription = docData<CandidateUser>(this.getUserDocRef(customerId, user.user.uid)).subscribe(u => {
                resolve(u);
            });
        });
    }

    async loginWithProvider(provider: string, email?: string) {
        let user: CandidateUser | undefined = undefined;
        switch (provider) {
            case 'google':
            case ProviderId.GOOGLE:
                user = await AuthService.googleLogin();
                break;
            case 'linkedin':
            case 'linkedin.com':
                user = await AuthService.linkedInLogin();
                break;
            case 'apple':
            case 'apple.com':
                user = await AuthService.appleLogin();
                break;
            case 'microsoft':
            case 'microsoft.com':
                user = await AuthService.microsoftLogin();
                break;
            case 'email':
                await AuthService.passwordLessLogin(email!);
                break;
            case 'saml.internal':
                await AuthService.samlLogin();
                const params = new URLSearchParams(new URL(window.location.href).search);
                if (!params.has('overrideEmployeeLogin')) {
                    params.set('overrideEmployeeLogin', 'true');
                    const url = new URL(window.location.href);
                    url.search = params.toString();
                    window.location.href = url.toString();
                }
                break;
            case 'oidc.internal':
                await AuthService.internalLogin();
                break;
        }

        if (user && user.tenantId) {
            this._user.next(user);
        }
        return user;
    }

    async internalLogin() {
        const customerId = this.getCustomerId();
        const auth = getAuth();
        const provider = new OAuthProvider('oidc.internal');

        if (baseStore.state.scopes) {
            const scopes = baseStore.state.scopes.split(' ');
            scopes.forEach((scope: string) => {
                provider.addScope(scope);
                console.log('adding scope: ' + scope);
            });
        }
        if (auth.currentUser && auth.currentUser.isAnonymous) {
            await deleteDoc(this.getUserDocRef(customerId, auth.currentUser.uid));
            await auth.currentUser.delete();
        }
        if (!this.mergeInternal) {
            await signInWithPopup(auth, provider);
        }
    }

    async oidcLogin() {
        const customerId = this.getCustomerId();
        const auth = getAuth();
        const provider = new OAuthProvider('oidc.test');
        provider.setCustomParameters({
            // Optional "tenant" parameter in case you are using an Azure AD tenant.
            // eg. '8eaef023-2b34-4da1-9baa-8bc8c9d6a490' or 'contoso.onmicrosoft.com'
            // or "common" for tenant-independent tokens.
            // The default value is "common".
            tenant: getConfigValue('microsoftClientId'),
        });
        provider.addScope('User.Read');
        provider.addScope('openid');
        provider.addScope('profile');

        let user: UserCredential;
        if (auth.currentUser && auth.currentUser.isAnonymous) {
            await deleteDoc(this.getUserDocRef(customerId, auth.currentUser.uid));
            await auth.currentUser.delete();
        }
        user = await signInWithPopup(auth, provider);
        console.log(user);
        // console.log(user.credential.a)

        const response = await fetch(`https://graph.microsoft.com/v1.0/me`, {
            method: 'GET',
            // body: JSON.stringify({ customerId, language, brand }),
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + (await user.user.getIdTokenResult()).token, //TODO: ????
            },
        });

        console.log(response.status);
        console.log(await response.json());

        const additionalUserInfo = getAdditionalUserInfo(user);
        if (additionalUserInfo?.isNewUser) {
            baseStore.state.newUser = true;
            console.log('Updating tenant for new user');
            // await this.updateTenant();
        }

        return new Promise<CandidateUser | undefined>(resolve => {
            this.userSubscription = docData<CandidateUser>(this.getUserDocRef(customerId, user.user.uid)).subscribe(u => {
                resolve(u);
            });
        });
    }

    async samlLogin() {
        const customerId = this.getCustomerId();
        const auth = getAuth();

        const provider = new SAMLAuthProvider('saml.internal');

        let user: UserCredential;
        if (auth.currentUser && auth.currentUser.isAnonymous) {
            await deleteDoc(this.getUserDocRef(customerId, auth.currentUser.uid));
            await auth.currentUser.delete();
        }
        user = await signInWithPopup(auth, provider);
        const additionalUserInfo = getAdditionalUserInfo(user);
        if (additionalUserInfo?.isNewUser) {
            baseStore.state.newUser = true;
            console.log('Updating tenant for new user');
            // await this.updateTenant();
        }

        return new Promise<CandidateUser | undefined>(resolve => {
            this.userSubscription = docData<CandidateUser>(this.getUserDocRef(customerId, user.user.uid)).subscribe(u => {
                resolve(u);
            });
        });
    }

    public async signUp(email: string, pw: string) {
        const customerId = this.getCustomerId();
        const auth = getAuth();
        const user = await createUserWithEmailAndPassword(auth, email, pw);
        baseStore.state.newUser = true;

        return new Promise<CandidateUser | undefined>(resolve => {
            this.userSubscription = docData<CandidateUser>(this.getUserDocRef(customerId, user.user.uid)).subscribe(u => {
                this._user.next(u);
                resolve(u);
            });
        });
    }

    public async createOrGetTempUser() {
        let fbUser: User;
        const customerId = this.getCustomerId();
        const auth = getAuth();
        if (auth.currentUser) {
            fbUser = auth.currentUser;
            try {
                await fbUser.getIdToken(true);
            } catch (error) {
                const err = error as any;
                globalTrackingService.trackClientEvent('Could not refresh token for uid: ' + fbUser.uid, 3, err);
            }
            let userId = fbUser.uid;
            console.log('Using currently logged on user: ' + userId);
            const favoriteJobsItem = localStorage.getItem('favoriteJobs');
            let favoriteJobs = [];
            if (favoriteJobsItem) {
                favoriteJobs = JSON.parse(favoriteJobsItem);
            }
            if (fbUser.isAnonymous) {
                baseStore.state.user = { ...fbUser, enabled: false, favoriteJobs };
            } else {
                let userDocSnap = await this.getUserDocSnap(customerId, userId);
                if (!userDocSnap.exists()) {
                    const newCandidateUser: CandidateUser = {
                        email: fbUser.email,
                        uid: fbUser.uid,
                        enabled: false,
                        tenantId: customerId,
                        isAnonymous: false,
                        favoriteJobs: favoriteJobs,
                    };
                    console.log('newCandidateUser', newCandidateUser);
                    await setDoc(this.getUserDocRef(customerId, userId), newCandidateUser, { merge: true });
                    let docRef = this.getUserDocRef(customerId, userId);
                    const docSnap = await getDoc(docRef);
                    if (docSnap.exists()) {
                        this._user.next(docSnap.data());
                    } else {
                        console.warn('Could not get doc for temp user');
                    }
                    // this.userSubscription = docData<CandidateUser>(docRef).pipe(first(u =>!!u.uid)).subscribe(u => {
                    //   this._user.next(u);
                    // });
                } else {
                    this.userSubscription = docData<CandidateUser>(this.getUserDocRef(customerId, userId))
                        .pipe(first(u => !!u?.uid))
                        .subscribe(u => {
                            this._user.next(u);
                        });
                }
            }
        } else {
            const user = await signInAnonymously(auth);
            // await this.updateTenant();
            fbUser = user.user;

            baseStore.state.user = { email: '', uid: fbUser.uid, enabled: false, isAnonymous: true, tenantId: fbUser.tenantId!, favoriteJobs: [] };
            console.log('Generated temp user with id ' + fbUser.uid);
            // this.userSubscription = docData<CandidateUser>(firebaseStore.doc(`customers/${customerId}/users/${user.user.uid}`)).pipe(first(u => u.isAnonymous)).subscribe(u => {
            //   this._user.next(u);
            // });
        }
        return fbUser;
    }

    public async setCandidate(favoriteJobs: FavoriteJob[]): Promise<void> {
        this._isInitializing.next(true);
        const fireFunctions = getFunctions();
        const setCandidateFunction = httpsCallable(fireFunctions, 'setCandidate');
        await setCandidateFunction({ customerId: this.getCustomerId(), favoriteJobs: favoriteJobs });

        //TODO: fire user subscription
        this._isInitializing.next(false);
        return;
    }

    public async logout(reloadPage: boolean = true) {
        try {
            const auth = getAuth();
            if (this.firebaseStoreUserSubscription) {
                this.firebaseStoreUserSubscription.unsubscribe();
            }
            if (this.userSubscription) {
                this.userSubscription.unsubscribe();
            }
            if (this.authSubscription) {
                this.authSubscription.unsubscribe();
            }
            if (baseStore.state) {
                baseStore.state.profile = undefined;
                baseStore.state.user = undefined;
                baseStore.state.email = undefined;
            }
            await auth.signOut();
            // indexedDB.deleteDatabase('firebaseLocalStorageDb');
            this._user.next(undefined);
            if (reloadPage) {
                window.location.reload();
            }
        } catch (error) {
            console.error(error);
        }
    }

    public isLoggedIn() {
        const auth = getAuth();
        return !!auth.currentUser;
    }

    public isAnonymous() {
        const auth = getAuth();
        return auth?.currentUser?.isAnonymous;
    }

    public getFavoriteJobs() {
        let favoriteJobs: any[] = [];
        if (baseStore.state.user && baseStore.state.user.favoriteJobs) {
            favoriteJobs = [...baseStore.state.user.favoriteJobs];
        }
        return favoriteJobs;
    }

    public async getFirstExistingProvider(email: string) {
        const auth = getAuth();
        const providers = await fetchSignInMethodsForEmail(auth, email);
        return providers?.[0];
    }

    public async signInAndLink(email: string, credentialToken: any) {
        const authCredential = OAuthCredential.fromJSON(credentialToken);
        if (!authCredential) {
            return;
        }
        const auth = getAuth();
        const providers = await fetchSignInMethodsForEmail(auth, email);
        console.log(providers);
        const firstProvider = providers[0];
        if (firstProvider) {
            let provider;
            switch (firstProvider) {
                case 'google':
                    provider = new GoogleAuthProvider();
                    break;
                case 'linkedin':
                    provider = new OAuthProvider('linkedin.com');
                    break;
                case 'apple':
                    provider = new OAuthProvider('apple.com');
                    break;
                case 'microsoft':
                    provider = new OAuthProvider('microsoft.com');
                    break;
            }
            if (provider) {
                const user = await signInWithPopup(auth, provider);
                await linkWithCredential(user.user, authCredential);
            }
        }
    }
}

export const AuthService = new AuthServiceController();
